module.exports = __webpack_public_path__ + "static/media/menu-light.4914176d.svg";